import { render, staticRenderFns } from "./MspPowerProfile.vue?vue&type=template&id=622269f8&scoped=true"
import script from "./MspPowerProfile.vue?vue&type=script&lang=js"
export * from "./MspPowerProfile.vue?vue&type=script&lang=js"
import style0 from "./MspPowerProfile.vue?vue&type=style&index=0&id=622269f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622269f8",
  null
  
)

export default component.exports